module.exports = __webpack_public_path__ + "img/moveup-logo.5d421fc4.png";